import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { create } from "@/store";
import environment from "@/modules/environment";

type StationState = {
  cameraOrder: string[];
  isViewerToCameraBannerDismissed: boolean;
};
type StationStore = StationState & {
  moveCameraToTop(jid: string): void;
  setIsViewerToCameraBannerDismissed(isViewerToCameraBannerDismissed: boolean): void;
  resetState(): void;
};

const initialState: StationState = {
  cameraOrder: [],
  isViewerToCameraBannerDismissed: false
};

const useStation = create<StationStore>()(
  persist(
    immer((set) => ({
      ...initialState,
      moveCameraToTop(jid) {
        set((state) => {
          const filtered = state.cameraOrder.filter((id) => id !== jid);
          state.cameraOrder = [jid, ...filtered];
        });
      },
      setIsViewerToCameraBannerDismissed(isViewerToCameraBannerDismissed) {
        set({ isViewerToCameraBannerDismissed });
      },
      resetState() {
        set(initialState);
      }
    })),
    {
      name: environment.appMode + "-station"
    }
  )
);

const stationStore = useStation.getState;

export { useStation, stationStore };
